// extracted by mini-css-extract-plugin
export var active = "_cy-2";
export var recordingDot = "_cy-1";
export var recordingIndicator = "_cy-0";